import React from 'react';
import PropTypes from 'prop-types';
import PackageSelector from './PackageSelector';
import dollarize from '../utils/displayHelpers';
import Styles from './summarytable.module.scss';

const PackageRow = props => (
  <tr >
    <th className="service"> <PackageSelector /></th>
    <td className={Styles.price}>{dollarize(props.price)}</td>
  </tr>
);

PackageRow.propTypes = {
  price: PropTypes.number,
};

PackageRow.defaultProps = {
  price: 0.00,
};

export default PackageRow;



// WEBPACK FOOTER //
// ./src/components/PackageRow.jsx